const lowestCurrentDateValidator = (value, options) => {
  if (!value) return null;

  var d = new Date(),
    ano_atual = d.getFullYear(),
    mes_atual = d.getMonth() + 1,
    dia_atual = d.getDate(),
    strDataAtualFormatada = mes_atual + '/' + dia_atual + '/' + ano_atual,
    split = value.split('/'),
    strDataFormatada = split[1] + '/' + split[0] + '/' + split[2],
    dtAtualFormatada = new Date(strDataAtualFormatada),
    dtFormatada = new Date(strDataFormatada);

  const invalidDate = dtFormatada > dtAtualFormatada;

  return invalidDate ? options.message : null;
};

export default lowestCurrentDateValidator;
